export function isEmailValid(email: string): boolean {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
}

export function isPasswordValid(password: string): boolean {
  return /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&]{8,}$/.test(password)
}

export function formatPrice(value: number): string {
  if (value === 0) {
    return '0'
  }

  if (!value) {
    return ''
  }

  const parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  if (parts[1]) parts[1] = parts[1].length === 1 ? parts[1] + '0' : parts[1].substr(0, 2)

  return parts.length > 1 ? `${parts.join('.')}` : `${parts[0]}.00`
}

export function formatNumericValue(value: number): string {
  if (value === 0) {
    return '0'
  }

  if (!value) {
    return ''
  }

  const parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  if (parts[1]) parts[1] = parts[1].length === 1 ? parts[1] + '0' : parts[1].substr(0, 2)

  return parts.length > 1 ? `${parts.join('.')}` : `${parts[0]}`
}

export function convertWorkType(workType: string): string {
  switch (workType) {
    case 'journal-article':
      return 'Journal Article'
    case 'book':
      return 'Book'
    case 'book-chapter':
      return 'Book Chapter'
    case 'manual':
      return 'Manual'
    case 'podcast':
      return 'Podcast'
    case 'podcast-episode':
      return 'Podcast Episode'
    case 'preprint':
      return 'Preprint'
    case 'dataset':
      return 'Dataset'
    case 'protocol':
      return 'Protocol'
    case 'presentation':
      return 'Presentation'
    case 'report':
      return 'Report'
    case 'software-code':
      return 'Software code'
    case 'audio':
      return 'Audio'
    case 'video':
      return 'Video'
    case 'website':
      return 'Website'
    default:
      return 'Other'
  }
}

export function getColorClassByGrantStatus(status: string): string {
  switch (status) {
    case 'Open':
      return 'text-primary'
    case 'In Progress':
      return 'text-primary-200'
    case 'Cancelled':
      return 'text-info-300'
    case 'Closed':
      return 'text-success-100'
    default:
      return 'text-danger-500'
  }
}

export function getColorByGrantStatus(status: string): string {
  switch (status) {
    case 'Open':
      return '#3874ff'
    case 'In Progress':
      return '#adc5ff'
    case 'Cancelled':
      return '#96d9ff'
    case 'Closed':
      return '#d9fbd0'
    default:
      return '#cc1b00'
  }
}
